export default __webpack_public_path__ + "static/media/UserProfile icon white.005ad96d.svg";